<template>
  <div>
    <div class="app-top">
      <div class="container">
        <h1>{{this.form.paymentNo?"订单详情":"订单确认"}}</h1>
        <div class="row" v-loading="loading">
          <!-- 左侧 -->
          <div class="col-12 col-sm-8">
            <div class="container-left box">
              <!-- ================================================网络版================================================== -->
              <div v-if="form.licenseType=='Network'">
                <!-- ====================================当前套餐==================================== -->
                <h2 v-if="tenantInfo.account">当前套餐</h2>
                <div class="box-info" v-if="tenantInfo.account">
                  <div>
                    <label>当前账户：</label>
                    <span class="box-value">{{tenantInfo.account}}</span>
                  </div>
                  <div>
                    <label>当前到餐：</label>
                    <span class="box-value">
                      {{tenantInfo.userCount}}用户
                      <span v-if="tenantInfo.storeCount>0">，{{tenantInfo.storeCount}}门店</span>
                    </span>
                  </div>
                  <div>
                    <label>到期时间：</label>
                    <span class="box-value">{{tenantInfo.validDate}}</span>
                  </div>
                </div>
                <!-- ====================================购买套餐==================================== -->
                <h2>选购产品</h2>
                <div class="box-info">
                  <div>
                    <label>产品名称：</label>
                    <span class="box-value">{{form.softName}}（{{form.licenseTypeText}}）</span>
                  </div>
                  <div>
                    <label>套餐内容：</label>
                    <span class="box-value">{{form.details[0].licenseValue}}{{form.details[0].licenseModuleText}}</span>
                  </div>
                  <div>
                    <label>有效期限：</label>
                    <span class="box-value">{{form.details[0].licenseTimeStart}} 至 {{form.details[0].licenseTimeEnd}}</span>
                  </div>
                  <div>
                    <label>价格：</label>
                    <span
                      class="box-value"
                      style="color: red;"
                    >￥{{(form.paymentAmount-(calcDetail.appendAmount>0?calcDetail.appendAmount:0)+form.freeAmount+form.couponAmount).toFixed(2)}}</span>
                  </div>
                </div>
                <!-- ====================================配置提升 补差价==================================== -->
                <h2 v-if="calcDetail.appendAmount>0">其他</h2>
                <div class="box-info" v-if="calcDetail.appendAmount>0">
                  <div>
                    <label>差价：</label>
                    <span class="box-value" style="color: red;">￥{{calcDetail.appendAmount.toFixed(2)}}</span>
                  </div>
                  <div>
                    <label>说明：</label>
                    <span class="box-value">{{calcDetail.title}}</span>
                  </div>
                  <div>
                    <label>范围：</label>
                    <span class="box-value">{{calcDetail.appendAmountRange}}</span>
                  </div>
                </div>

                <!-- ====================================配置降低 提示==================================== -->
                <div class="box-info" v-if="calcDetail.appendAmount<0" style="color: red;">
                  <p>{{calcDetail.title}}，配置立即生效</p>
                </div>

                <!-- ====================================买断版 提示==================================== -->
                <div
                  class="box-info"
                  v-if="new Date(calcDetail.licenseTimeEnd).getFullYear()>2099&&form.details[0].licenseModule=='User'"
                  style="color: red;"
                >
                  <p>【买断版说明】：</p>
                  <p>前4年无需支付其他费用，第5年开始按买断版原价每年支付10%服务器维护费即可。</p>
                  <p>买断版价格以当时买断版原价格为准，年费价格调整时不受影响。</p>
                </div>
              </div>
              <!-- ================================================电脑版================================================== -->
              <div v-if="form.licenseType=='Client_PC'">
                <h2>产品信息</h2>
                <div class="box-info">
                  <div>
                    <label>产品名称：</label>
                    <span class="box-value">{{form.softName}}</span>
                  </div>
                  <div>
                    <label>产品版本：</label>
                    <span class="box-value">{{form.licenseTypeText}}</span>
                  </div>
                  <!-- <div>
                    <label>产品编号：</label>
                    <span class="box-value">{{form.code}}</span>
                  </div>-->
                  <div>
                    <label>有效期限：</label>
                    <span class="box-value">{{form.details[0].licenseTimeStart}} 至 {{form.details[0].licenseTimeEnd}}</span>
                  </div>
                </div>
                <h2>授权码接收方式(短信)</h2>
                <div class="box-info">
                  <!-- <div>
                    <label>邮箱地址：</label>
                    <span class="box-value">{{form.contactEmail}}</span>
                  </div>-->
                  <div>
                    <label>手机号码：</label>
                    <span class="box-value">{{form.contactTel}}</span>
                  </div>
                </div>
              </div>
              <!-- ================================================加密狗、U盘版================================================== -->
              <div v-if="form.licenseType=='Client_DOG' || form.licenseType=='Client_USB'">
                <h2>产品信息</h2>
                <div class="box-info">
                  <div>
                    <label>产品名称：</label>
                    <span class="box-value">{{form.softName}}</span>
                  </div>
                  <div>
                    <label>产品版本：</label>
                    <span class="box-value">{{form.licenseTypeText}}</span>
                  </div>
                  <div>
                    <label>有效期限：</label>
                    <span class="box-value">{{form.details[0].licenseTimeStart}} 至 {{form.details[0].licenseTimeEnd}}</span>
                  </div>
                </div>
                <h2>收货地址</h2>
                <div class="box-info">
                  <div>
                    <label>收货姓名：</label>
                    <span class="box-value">{{form.contactName}}</span>
                  </div>
                  <div>
                    <label>联系电话：</label>
                    <span class="box-value">{{form.contactTel}}</span>
                  </div>
                  <div>
                    <label>详细地址：</label>
                    <span class="box-value">{{form.contactAddress}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧 -->
          <div class="col-12 col-sm-4">
            <div class="container-right box">
              <div class="box-info">
                <div>
                  <label>订单编号：</label>
                  <span>{{form.no}}</span>
                </div>
                <div v-if="form.freeAmount">
                  <label>立减金额：</label>
                  <span style="color:#F18544;">￥{{form.freeAmount.toFixed(2)}}</span>
                </div>
                <div v-if="form.couponAmount">
                  <label>优惠金额：</label>
                  <span style="color:#F18544;">￥{{form.couponAmount.toFixed(2)}}</span>
                </div>
                <div>
                  <label>订单金额：</label>
                  <span style="color:red;font-size:22px;">￥{{form.paymentAmount.toFixed(2)}}</span>
                </div>
              </div>
              <hr />
              <div v-if="amountTimeout">请重新提交订单</div>
              <div v-else-if="form.paymentNo" class="box-pay-success">已完成</div>
              <div v-else>
                <div class="row box-pay">
                  <div class="col" @click="paymode = 'weixin'">
                    <div :class="['paymode',paymode == 'weixin' ? 'paymode-active' : '']">
                      <img src="@/assets/images/icon/wx1.png" alt />
                      <span>微信</span>
                    </div>
                  </div>
                  <div class="col" @click="paymode = 'alipay'">
                    <div :class="['paymode',paymode == 'alipay' ? 'paymode-active' : '']">
                      <img src="@/assets/images/icon/zfb1.png" alt />
                      <span>支付宝</span>
                    </div>
                  </div>
                </div>
                <div style="margin:20px 0;">
                  <button type="button" class="btn btn-danger" style="width:100%" @click="handleSave">支付</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="微信支付" :visible.sync="dialogVisible" @close="dialogClose" width="400px">
      <div style="width: 100%; display: flex; justify-content: center;margin-top:10px;">
        <div style="border:1px solid #ddd;padding:10px">
          <div ref="qrCodeUrl"></div>
        </div>
      </div>
      <div style="text-align:center;margin-top:10px;">打开微信，扫码支付</div>
      <div style="text-align:center;margin-top:10px; color:#999;font-size:12px;">如需发票，支付成功后联系客服，提供开票信息</div>
      <div style="text-align:center;margin-top:10px; font-size: 18px; color: red;font-weight: bold;">￥{{form.paymentAmount.toFixed(2)}}</div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/order'
import QRCode from 'qrcodejs2'
import API_USER from '@/api/user'
import API_ORDER from '@/api/order'

export default {
  name: 'OrderConfirm',
  data() {
    return {
      loading: false,
      form: {
        paymentAmount: 0,
        freeAmount: 0,
        couponAmount: 0,
        details: [
          {
            licenseValue: '',
            licenseModuleText: ''
          }
        ]
      },
      calcDetail: {
        otherAmount: 0
      },
      years: '',
      paymode: 'weixin',
      no: '',
      timer: null,
      timeCount: 0,
      dialogVisible: false,
      text: '',
      tenantInfo: {},
      amountTimeout: false
    }
  },
  watch: {},
  computed: {},
  created() {
    console.log(this.$route.params)
    this.no = this.$route.query.orderNo
    this.years = this.$route.query.years
    this.getUserInfo()
      .then(() => {
        this.getOne()
      })
      .catch(() => {
        this.getOne()
      })
  },
  methods: {
    //获取用户信息账户
    getUserInfo() {
      return new Promise((resolve, reject) => {
        API_USER.getInfo({})
          .then(res => {
            this.tenantInfo = {
              account: res.data.tenantAccount,
              name: res.data.tenantName,
              code: res.data.tenantCode,
              logoUrl: res.data.tenantLogoUrl,
              validDate: res.data.tenantValidDate,
              userCount: res.data.tenantUserCount,
              storeCount: res.data.tenantStoreCount
            }
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    setDetails() {
      return [
        {
          currentType: 'None',
          currentTypeText: '未开通',
          licenseTimeEnd: '0001-01-01',
          licenseModule: this.form.details[0].licenseModule,
          changeType: this.years >= 1 ? 'BuyYears' : 'BuyForever',
          licenseValue: this.form.details[0].licenseValue,
          years: this.years
        }
      ]
    },
    //获取价格
    calcAmount(account) {
      let obj = {
        product: this.utils.getProductCode(),
        licenseType: this.form.licenseType,
        freeCode: this.form.freeCode,
        couponId: this.form.couponId,
        tenantAccount: account,
        details: this.setDetails()
      }
      API_ORDER.postOrderCalcAmount(obj).then(res => {
        console.log('postOrderCalcAmount', res)
        this.calcDetail = res.data.details[0]
        //验证金额是否有变化
        let amount = 0
        res.data.details.forEach(item => {
          amount += item.amount
        })
        amount = amount - res.data.freeAmount - res.data.couponAmount
        if (amount != this.form.paymentAmount) {
          this.$Message({
            showClose: true,
            message: '订单已过期，请重新提交订单',
            type: 'error'
          })
          this.amountTimeout = true
        }
      })
    },
    getOne() {
      this.loading = true
      API.getOne({ no: this.no }).then(res => {
        this.loading = false
        this.form = res.data
        if (res.data.licenseType === 'Network') {
          this.calcAmount(res.data.tenantAccount)
        }
      })
    },
    handleSave() {
      if (this.paymode === 'alipay') {
        this.$Message({
          showClose: true,
          message: '支付宝暂不支持，请使用微信支付。',
          type: 'error'
        })
        return false
      }
      this.loading = true
      API.wxPayQrCode({ type: 'order', no: this.no }).then(res => {
        this.loading = false
        console.log(res)
        // this.$bvModal.show('exampleModalCenterTitle')
        this.dialogVisible = true
        this.text = res.data
        this.$nextTick(() => {
          //生成二维码的方法
          this.creatQrCode()
        })
        this.timeCount = 100
        this.setTimer()
      })
    },
    creatQrCode() {
      this.$refs.qrCodeUrl.innerHTML = ''
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.text, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000', //二维码颜色
        colorLight: '#ffffff' //二维码背景色
      })
    },
    setTimer() {
      this.timer = setTimeout(() => {
        if (this.timeCount > 0) {
          API.getOne({ no: this.no })
            .then(res => {
              console.log(res)
              this.timeCount--
              if (res.data.paymentNo) {
                clearTimeout(this.timer)
                this.form = res.data
                this.$msgbox.alert('支付成功', '信息', {
                  confirmButtonText: '确定',
                  callback: () => {
                    this.dialogVisible = false
                  }
                })
              } else {
                this.setTimer()
              }
            })
            .catch(() => {
              this.timeCount--
              this.setTimer()
            })
        } else {
          clearTimeout(this.timer)
          this.$msgbox.alert('支付连接超时请重新支付', '信息', {
            confirmButtonText: '确定',
            callback: () => {
              this.dialogVisible = false
            }
          })
        }
      }, 3000)
    },
    dialogClose() {
      clearTimeout(this.timer)
    }
  },
  beforeRouteLeave(to, form, next) {
    clearTimeout(this.timer)
    next()
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  h1 {
    padding: 5px 0 -15px 10px !important;
    font-size: 18px !important;
  }
  .box {
    padding-bottom: 5px !important;
    margin: 5px 0 5px 0 !important;
    h2 {
      font-size: 16px !important;
      margin-bottom: 10px !important;
    }
    .box-info {
      font-size: 14px !important;
      margin-bottom: 15px !important;
    }
  }
}

// 结束
.app-top {
  margin-top: 58px;
  min-height: calc(100vh - 370px);
  position: relative;
  background: #f8f8f8;
}
h1 {
  padding: 20px 0 0 20px;
  font-size: 24px;
  color: #333;
}

.box {
  color: #888;
  background: #ffffff;
  margin: 10px 0 30px 0;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07);
  // box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-top: #ddd 3px solid;
  h2 {
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
  }
  .box-info {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 22px;
    padding-left: 10px;
    label {
      width: 70px;
      text-align: right;
    }
    .box-value {
      color: #333;
    }
  }
  .box-pay {
    display: flex;
    align-items: center;

    .paymode {
      margin-top: 10px;
      text-align: center;
      border: 1px solid #eee;
      cursor: pointer;
      // border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 0;
      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
    .paymode:hover {
      background: #f8f8f8;
    }
    .paymode-active {
      position: relative;
      border: 1px solid #eee;
    }
    .paymode-active:after {
      position: absolute;
      content: '';
      width: 30px;
      height: 30px;
      right: 0;
      bottom: 0;
      background: url('../../assets/images/icon/selected_60.png') no-repeat;
      background-size: cover;
      z-index: 5;
    }
    .free-style {
      font-size: 14px;
      color: rgb(253, 13, 13);
    }
  }
  .box-pay-success {
    text-align: right;
    color: #999;
  }
}

.title {
  display: flex;
  align-items: center;
  h3 {
    font-size: 20px;
    margin-left: 10px;
  }
  img {
    width: 32px;
  }
  .tag {
    padding: 2px 5px;
    font-size: 18px;
    font-weight: lighter;
    color: #000;
    background: #fff;
    border: 1px #ddd solid;
    border-radius: 5px;
    margin-left: 10px;
  }
}

.wrap-qrcode {
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.5);
    position: absolute;
    z-index: -1;
  }
  .Qrcode {
    width: 320px;
    height: 320px;
    border-radius: 10px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .cose {
    margin-top: 20px;
    width: 50px;
    height: 50px;
    background: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    cursor: pointer;
  }
}
</style>